<template>
  <v-navigation-drawer
    v-model="toggle"
    fixed app>
    <v-toolbar flat dark :color="$root.themeColor" class="toolbar">
      <router-link :to="{ name: 'Dashboard' }">
        <img src="@/assets/plantiful.jpg" width="128px"></img>
      </router-link>
      <router-link :to="{ name: 'Dashboard' }" class="text">
         Admin Page
      </router-link>
    </v-toolbar>
    <v-list>
      <v-list-tile @click="changeRoute('Dashboard', 1)">
        <v-list-tile-action>
          <v-icon>dashboard</v-icon>
        </v-list-tile-action>
        <v-list-tile-title :class="[{'active': selectedIndex === 1}, 'item-title' ]" >{{ $t('dashboard') }}</v-list-tile-title>
      </v-list-tile>

      <v-list-tile @click="changeRoute('Order', 2)">
        <v-list-tile-action>
          <v-icon>shopping_cart</v-icon>
        </v-list-tile-action>
        <v-list-tile-title :class="[{'active': selectedIndex === 2}, 'item-title' ]">{{ $t('Order') }}</v-list-tile-title>
      </v-list-tile>

      <v-list-tile @click="changeRoute('pickinglist', 3)">
        <v-list-tile-action>
          <v-icon>description</v-icon>
        </v-list-tile-action>
        <v-list-tile-title :class="[{'active': selectedIndex === 3}, 'item-title' ]">{{ $t('Picking List') }}</v-list-tile-title>
      </v-list-tile>

      <v-list-tile @click="changeRoute('Customer', 4)">
        <v-list-tile-action>
          <v-icon>people</v-icon>
        </v-list-tile-action>
        <v-list-tile-title :class="[{'active': selectedIndex === 4}, 'item-title' ]">{{ $t('Customer') }}</v-list-tile-title>
      </v-list-tile>

      <v-list-tile @click="changeRoute('Customer_log', 5)">
        <v-list-tile-action>
          <v-icon>folder_open</v-icon>
        </v-list-tile-action>
        <v-list-tile-title :class="[{'active': selectedIndex === 5}, 'item-title' ]">{{ $t('Customer log') }}</v-list-tile-title>
      </v-list-tile>

      <v-list-tile @click="changeRoute('Product', 6)">
        <v-list-tile-action>
          <v-icon>fastfood</v-icon>
        </v-list-tile-action>
        <v-list-tile-title :class="[{'active': selectedIndex === 6}, 'item-title' ]">{{ $t('Product') }}</v-list-tile-title>
      </v-list-tile>
      
      <v-list-tile @click="changeRoute('Product', 7)">
        <v-list-tile-action>
          <v-icon>cake</v-icon>
        </v-list-tile-action>
        <v-list-tile-title :class="[{'active': selectedIndex === 7}, 'item-title' ]">{{ $t('SProduct') }}</v-list-tile-title>
      </v-list-tile>


      <v-list-tile @click="changeRoute('weeklymenu', 8)">
        <v-list-tile-action>
          <v-icon>album</v-icon>
        </v-list-tile-action>
        <v-list-tile-title :class="[{'active': selectedIndex === 8}, 'item-title' ]">{{ $t('Weekly Menu') }}</v-list-tile-title>
      </v-list-tile>

      <v-list-tile @click="changeRoute('addon_menu', 9)">
        <v-list-tile-action>
          <v-icon>album</v-icon>
        </v-list-tile-action>
        <v-list-tile-title :class="[{'active': selectedIndex === 9}, 'item-title' ]">{{ $t('Addon Menu') }}</v-list-tile-title>
      </v-list-tile>

      <v-list-tile @click="changeRoute('maporder1', 10)">
        <v-list-tile-action>
          <v-icon>map</v-icon>
        </v-list-tile-action>
        <v-list-tile-title :class="[{'active': selectedIndex === 10}, 'item-title' ]">{{ $t('Map Order') }}</v-list-tile-title>
      </v-list-tile>

      <v-list-tile @click="changeRoute('branchorder', 11)">
        <v-list-tile-action>
          <v-icon>view_list</v-icon>
        </v-list-tile-action>
        <v-list-tile-title :class="[{'active': selectedIndex === 11}, 'item-title' ]">{{ $t('Branch <> Center') }}</v-list-tile-title>
      </v-list-tile>

    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    toggle: {
        type: Boolean,
        required: false,
        default: true
    }
  },

  data() {
    return {
      selectedIndex: 1
    }
  },

  methods: {
    changeRoute(routeName, selectedIndex) {
      const vm = this;

      vm.selectedIndex = selectedIndex;

      return vm.$router.push({ name: routeName });
    }
  }
}
</script>

<style>
  .toolbar {
    font-weight: bold;
    font-size: 18px;
  }

  .toolbar .text {
    padding-left: 15px;
    color: white;
    text-decoration:none;
  }

  .item-title {
    font-size: 17px;
    font-weight: 500;
  }
  .item-sub-title {
    font-size: 15px;
    font-weight: 500;
  }

  .active {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/core/NavigationDrawer.vue